module.exports = __webpack_public_path__ + "static/media/mailnews_18.0281d2b7.ico";